export default "__VITE_ASSET__Di0PxBDp__"